import { useMemo } from 'react';
import { startOfDay, subYears, subMonths, getDate, subDays } from 'date-fns';
import { Modifier } from 'react-day-picker';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';
import { reinterpretUTCAsLocalDate } from 'src/components/common/InsightsDateRangeControl/InsightsDateRangeControl.utils';

export interface InsightsDateRangeConstraints {
  today: Date;
  initialMonth: Date;
  minDate: Date;
  maxDate: Date;
  disabledDays: Modifier[];
}

export const useInsightsDateRangeConstraints =
  (): InsightsDateRangeConstraints => {
    // TODO: that hooks is used in L2 component and reads values from the context
    // so need to find a way how to handle that pattern in future
    const { dataLastUpdated } = useBusinessInsightsContext();

    const today = useMemo(() => startOfDay(new Date()), []);

    const initialMonth = getDate(today) === 1 ? subMonths(today, 1) : today;

    const minDate = subYears(today, 2);

    const maxDate = useMemo(() => {
      const formattedDataLastUpdated =
        reinterpretUTCAsLocalDate(dataLastUpdated);

      if (formattedDataLastUpdated) {
        return formattedDataLastUpdated;
      }

      return subDays(today, 1);
    }, [dataLastUpdated, today]);

    const disabledDays = useMemo(
      (): Modifier[] => [{ before: minDate }, { after: maxDate }],
      [minDate, maxDate]
    );

    return { today, initialMonth, minDate, maxDate, disabledDays };
  };
